import { Component, Mixins } from 'vue-property-decorator';
import CommonAppConfigMixin from '@/mixins/commonAppConfigMixin';
import { ID_TYPE } from '@/models/enums/id-type';
import { AnalyticsService } from '@/services/analytics.service';
import isMobile from '@/utils/isMobile';
import { DEVICE } from '@/models/enums/device.enum';
import i18n from '@/plugins/i18n';
import { SurveysService } from '@/services/surveys.service';
import { ANALYTICS_ACTIONS } from '@/models/enums/analytics-actions.enum';

const ENGLISH_RB_SLUG = 'flexrent';
@Component
export default class AppConfigMixin extends Mixins(CommonAppConfigMixin) {
  get surveyId(): string | null {
    return this.$store.state.surveyId;
  }
  async setDefaultFacility(redirectCallback: () => void) {
    if (this.$store.state.originLink === null) {
      this.$store.dispatch('setOriginLink', location.href);
    }
    if (this.$route.params.type && this.$route.params.id) {
      try {
        if (this.$route.params.type === ID_TYPE.STORE_CODE) {
          await this.$store.dispatch(
            'setDefaultFacilityByStoreCode',
            this.$route.params.id
          );
        } else if (this.$route.params.type === ID_TYPE.FACILITY_ID) {
          await this.$store.dispatch(
            'setDefaultFacilityById',
            this.$route.params.id
          );
        }
        this.$store.dispatch('setIsLoading', false);
      } catch (err) {
        redirectCallback();
        this.$store.dispatch('setIsLoading', false);
      }
    } else if (this.$route.params.type && !this.$route.params.id) {
      redirectCallback();
    }
    this.$store.dispatch('setIsLoading', false);
  }

  async setBasicData() {
    await this.setConfig(() => {
      if (this.$store.getters.slug === ENGLISH_RB_SLUG) {
        i18n.locale = 'en';
        document.documentElement.lang = this.$i18n.locale;
      }
      document.title = this.$t('metaTitle').toString();
    });
  }

  async setConfig(callback: () => void = () => {}) {
    this.$store.dispatch('setIsLoading', true);
    try {
      await this.$store.dispatch('setConfig', this.$route.params.slug);
      callback();
      this.$store.dispatch('setIsLoading', false);
    } catch (err) {
      this.$store.dispatch('setIsLoading', false);
      this.$router.push({
        name: 'error',
      });
    }
  }

  sendAnalytics() {
    return AnalyticsService.sendAnalytics({
      action: 1,
      ...(this.$store.state.defaultFacility && {
        gmb_address: this.$store.state.defaultFacility.gmbAddressId,
      }),
      medium: isMobile() ? DEVICE.MOBILE : DEVICE.DESKTOP,
    });
  }

  sendSurveyAnalytics(action: ANALYTICS_ACTIONS, survey: string) {
    return SurveysService.sendSurveyAnalytics({
      action,
      survey,
      medium: isMobile() ? DEVICE.MOBILE : DEVICE.DESKTOP,
    });
  }
}
